export default __webpack_public_path__ + "static/optinlygozen-a0b038a8fb68eec512e22e074fd412ce.svg";